import {
  CallOemPartialSaveRequestPayload,
  DeclinePartialSaveRequestPayload,
  OdometerPartialSaveRequestPayload,
} from "../types";

export const SUBMIT_ODOMETER_PARTIAL_SAVE_REQUEST = "@@WarrantyDeflection/SUBMIT_ODOMETER_PARTIAL_SAVE_REQUEST" as const;
export const SUBMIT_ODOMETER_PARTIAL_SAVE_SUCCESS = "@@WarrantyDeflection/SUBMIT_ODOMETER_PARTIAL_SAVE_SUCCESS" as const;
export const SUBMIT_ODOMETER_PARTIAL_SAVE_FAILED = "@@WarrantyDeflection/SUBMIT_ODOMETER_PARTIAL_SAVE_FAILED" as const;

export const SUBMIT_CALL_OEM_PARTIAL_SAVE_REQUEST = "@@WarrantyDeflection/SUBMIT_CALL_OEM_PARTIAL_SAVE_REQUEST" as const;
export const SUBMIT_CALL_OEM_PARTIAL_SAVE_SUCCESS = "@@WarrantyDeflection/SUBMIT_CALL_OEM_PARTIAL_SAVE_SUCCESS" as const;
export const SUBMIT_CALL_OEM_PARTIAL_SAVE_FAILED = "@@WarrantyDeflection/SUBMIT_CALL_OEM_PARTIAL_SAVE_FAILED" as const;

export const SUBMIT_DECLINE_PARTIAL_SAVE_REQUEST = "@@WarrantyDeflection/SUBMIT_DECLINE_PARTIAL_SAVE_REQUEST" as const;
export const SUBMIT_DECLINE_PARTIAL_SAVE_SUCCESS = "@@WarrantyDeflection/SUBMIT_DECLINE_PARTIAL_SAVE_SUCCESS" as const;
export const SUBMIT_DECLINE_PARTIAL_SAVE_FAILED = "@@WarrantyDeflection/SUBMIT_DECLINE_PARTIAL_SAVE_FAILED" as const;

export const submitOdometerPartialSaveRequest = (payload: OdometerPartialSaveRequestPayload) =>
  ({ type: SUBMIT_ODOMETER_PARTIAL_SAVE_REQUEST, payload } as const);

export const submitOdometerPartialSaveSuccess = () =>
  ({ type: SUBMIT_ODOMETER_PARTIAL_SAVE_SUCCESS } as const);

export const submitOdometerPartialSaveFailed = (payload: any) =>
  ({ type: SUBMIT_ODOMETER_PARTIAL_SAVE_FAILED, payload } as const);

export const submitCallOemPartialSaveRequest = (payload: CallOemPartialSaveRequestPayload) =>
  ({ type: SUBMIT_CALL_OEM_PARTIAL_SAVE_REQUEST, payload } as const);

export const submitCallOemPartialSaveSuccess = () =>
  ({ type: SUBMIT_CALL_OEM_PARTIAL_SAVE_SUCCESS } as const);

export const submitCallOemPartialSaveFailed = (payload: any) =>
  ({ type: SUBMIT_CALL_OEM_PARTIAL_SAVE_FAILED, payload } as const);

export const submitDeclinePartialSaveRequest = (payload: DeclinePartialSaveRequestPayload) =>
  ({ type: SUBMIT_DECLINE_PARTIAL_SAVE_REQUEST, payload } as const);

export const submitDeclinePartialSaveSuccess = () =>
  ({ type: SUBMIT_DECLINE_PARTIAL_SAVE_SUCCESS } as const);

export const submitDeclinePartialSaveFailed = (payload: any) =>
  ({ type: SUBMIT_DECLINE_PARTIAL_SAVE_FAILED, payload } as const);

export type WarrantyDeflectionAction =
  | ReturnType<typeof submitOdometerPartialSaveRequest>
  | ReturnType<typeof submitOdometerPartialSaveSuccess>
  | ReturnType<typeof submitOdometerPartialSaveFailed>
  | ReturnType<typeof submitCallOemPartialSaveRequest>
  | ReturnType<typeof submitCallOemPartialSaveSuccess>
  | ReturnType<typeof submitCallOemPartialSaveFailed>
  | ReturnType<typeof submitDeclinePartialSaveRequest>
  | ReturnType<typeof submitDeclinePartialSaveSuccess>
  | ReturnType<typeof submitDeclinePartialSaveFailed>;
